import { Component, computed, Signal, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { GoToStep, UpdateRegisterBizDetails } from '../../../../store/onboarding/onboarding.actions';
import { BoFormsModule } from '@bo/ng-forms';
import { AppFormComponent } from '../../../../shared/classes/app-form';
import { Observable } from 'rxjs';
import { OnboardingSelectors } from '../../../../store/onboarding/onboarding.selectors';
import { Method } from '@bo/ng-api';
import { FieldComponent } from '../../../../shared/components/forms/form-field/form-field.component';
import { SubmitComponent } from '../../../../shared/components/forms/submit/submit.component';
import { RegistrationBizDataModel } from '../../../../_interfaces/registration_response.interface';
import { OnboardingSteps } from '../../../../store/onboarding/onboarding.model';
import { Router } from '@angular/router';
import { RegisterService } from '../../../../_services/register-service/register.service';
import { RouterSwitchBtnComponent } from '../../../../shared/components/router-switch-btn/router-switch-btn.component';
import { LoaderComponent } from '../../../../shared/components/loader/loader.component';

@Component({
  imports: [BoFormsModule, FieldComponent, SubmitComponent, RouterSwitchBtnComponent, LoaderComponent],
  templateUrl: './business-details.component.html',
})
export class BusinessDetailsComponent extends AppFormComponent<RegistrationBizDataModel> {
  readonly registerService = inject(RegisterService);
  readonly store = inject(Store);
  readonly router = inject(Router);

  protected override fields: string[] = ['name', 'size', 'type'];
  step: OnboardingSteps = 1;
  private readonly signup: Signal<string> = computed(
    () => <string>this.store.selectSnapshot(OnboardingSelectors.signupID),
  );

  constructor() {
    super();
    this.store.dispatch(new GoToStep(OnboardingSteps.BUSINESS_DETAILS));
    this.store.select(OnboardingSelectors.step).subscribe({
      next: (res) => (this.step = res),
    });
  }

  override createForm(): void {
    this.buildFromOptions(this.registerService.getOptions(`signup/${this.signup()}/business/`, Method.POST)).subscribe({
      next: () => {
        this.fillFormFromStore();
      },
    });
  }

  fillFormFromStore() {
    const cachedValue = this.store.selectSnapshot(OnboardingSelectors.businessDetails);
    if (this.form && cachedValue) {
      this.form.patchValue({
        ...cachedValue,
      });
    }
  }

  override handleSubmitSuccess(data: RegistrationBizDataModel): void {
    this.store.dispatch(new UpdateRegisterBizDetails(data)).subscribe({
      next: () => {
        this.router.navigate(['/sign-up/verify-email']);
      },
    });
  }

  override submitData(formData: RegistrationBizDataModel): Observable<RegistrationBizDataModel> {
    const data: RegistrationBizDataModel = formData;
    data.signup = this.signup();
    return this.registerService.register_biz(this.signup(), data);
  }
}
